import { z } from 'zod';

export const planSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    description: z
        .string()
        .max(1000)
        .optional()
        .or(z.literal(''))
        .transform((v) => (v === '' ? undefined : v)),
    status: z.enum(['active', 'retired']).default('active'),
    is_looped: z.boolean().default(false),
});

export type PlanFormInput = z.input<typeof planSchema>;
export type PlanFormOutput = z.output<typeof planSchema>;
